module.exports = __webpack_public_path__ + "img/code.4173faa9.jpg";